<template>
  <div class="template2">
    <!-- 主内容区 -->
    <div class="t2-content">
      <!-- QR码分享区域 -->
      <div class="t2-qr-section">
        <div class="t2-qr-top">
          <div class="t2-qr-left">
            <div class="t2-qr-placeholder">
              <van-icon name="qr" size="60" color="#DFB372" />
            </div>
            <div class="t2-qr-tip">保存邀请码</div>
          </div>
          <div class="t2-qr-right">
            <div class="t2-share-link">
              <input type="text" class="t2-link-input" :value="inviteLink" readonly />
              <svg class="t2-link-copy" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" @click="copyLink">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
            </div>
            <div class="t2-share-buttons">
              <div class="t2-share-item" @click="handleShare()">
                <div class="t2-share-icon-share">
                  <svg width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="#DFB372" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="18" cy="5" r="3"></circle>
                    <circle cx="6" cy="12" r="3"></circle>
                    <circle cx="18" cy="19" r="3"></circle>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                  </svg>
                </div>
                <span class="t2-share-text">分享</span>
              </div>
              <div class="t2-share-item" @click="shareToPlatform('wechat')">
                <img src="/static/image/promote/home/img_wx.png" class="t2-share-icon-img" />
                <span class="t2-share-text">Wechat</span>
              </div>
              <div class="t2-share-item" @click="shareToPlatform('qq')">
                <img src="/static/image/promote/home/img_qq.png" class="t2-share-icon-img" />
                <span class="t2-share-text">QQ</span>
              </div>
              <div class="t2-share-item" @click="shareToPlatform('moments')">
                <img src="/static/image/promote/home/img_pyq.png" class="t2-share-icon-img" />
                <span class="t2-share-text">WeChat</span>
                <span class="t2-share-text" style="margin-top:0;">Moments</span>
              </div>
              <div class="t2-share-item" @click="shareToPlatform('facebook')">
                <img src="/static/image/promote/home/img_facebook.png" class="t2-share-icon-img" />
                <span class="t2-share-text">Facebook</span>
              </div>
              <div class="t2-share-item" @click="shareToPlatform('telegram')">
                <img src="/static/image/promote/home/img_tg.png" class="t2-share-icon-img" />
                <span class="t2-share-text">Telegram</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 有效下级信息 -->
        <div class="t2-sub-info">
          <span>有效下级 <strong>{{ effectiveSubCount }}</strong> 人</span>
          <span class="t2-detail-link" @click="showDetail = !showDetail">详情</span>
        </div>
      </div>

      <!-- 什么是有效推广人数 -->
      <div class="t2-explain-card">
        <div class="t2-explain-title">什么是有效推广人数?</div>
        <div class="t2-explain-text">
          <p>该下级累计充值值≥1000，累计有效投注≥6000，累计充值天数≥5并且使用APP登录才算有效</p>
          <p>有效投注仅限：</p>
          <p><strong>棋牌：</strong>开元(抢庄牛牛，极速炸金花，经典斗地主，通比... <span class="more-link">更多</span></p>
          <p><strong>捕鱼：</strong>WG，WL，JDB，CQ9</p>
          <p><strong>电子：</strong>WG(超级水果机，麻将胡了，麻将胡了2，赏金女... <span class="more-link">更多</span></p>
        </div>
      </div>

      <!-- 推广奖励网格 -->
      <div class="t2-grid-section">
        <div class="t2-grid-container">
          <template v-for="(row, ri) in gridRows">
            <template v-for="(item, ci) in row.items">
              <div class="t2-grid-cell" :key="'cell-' + ri + '-' + ci">
                <div class="t2-cell-wrap">
                  <div class="t2-cell-inner">
                    <div class="t2-cell-btn">开</div>
                    <div class="t2-cell-label">推广{{ item.num }}人</div>
                  </div>
                  <div class="t2-cell-reward">{{ item.reward.toFixed(2) }}</div>
                </div>
              </div>
              <div class="t2-arrow-h-col" :class="{ 'is-reverse': row.isReverse }" v-if="ci < row.items.length - 1" :key="'arrow-' + ri + '-' + ci">
                {{ row.isReverse ? '《' : '》' }}
              </div>
            </template>
            <!-- 垂直箭头行 -->
            <template v-if="ri < gridRows.length - 1">
              <div class="t2-v-arrow-cell" v-if="row.isReverse">》</div>
              <div class="t2-v-arrow-cell" v-else></div>
              <div class="t2-arrow-h-col"></div>
              <div class="t2-v-arrow-cell"></div>
              <div class="t2-arrow-h-col"></div>
              <div class="t2-v-arrow-cell"></div>
              <div class="t2-arrow-h-col"></div>
              <div class="t2-v-arrow-cell" v-if="!row.isReverse">》</div>
              <div class="t2-v-arrow-cell" v-else></div>
            </template>
          </template>
        </div>
      </div>

      <!-- 活动说明 -->
      <div class="t2-rules-card" v-if="activityMemo">
        <div class="t2-rules-title-wrap">
          <div class="t2-rules-title">活动说明</div>
        </div>
        <div class="t2-rules-content" v-html="activityMemo"></div>
      </div>

      <!-- 底部推荐图横向滑动 -->
      <div class="t2-recommend" v-if="recommendList.length > 0" ref="recommendWrap">
        <div class="t2-recommend-inner" ref="recommendInner">
          <div
            v-for="(item, index) in recommendList"
            :key="index"
            class="t2-recommend-item"
            :ref="'recItem' + index"
            :class="{ 't2-recommend-active': item.activityId === String(activityData.id) }"
            @click="goRecommend(item)"
          >
            <img :src="item.image" class="t2-recommend-img" alt="" />
            <div class="t2-recommend-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
      <div class="popup-content">
        <div class="popup-close" @click="closePopup">
          <img src="/static/image/event/close_popup.png" alt="关闭" />
        </div>
        <div class="popup-body">
          <img :src="popupItem.image" class="popup-img" alt="" />
          <div class="popup-name">{{ popupItem.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendList } from './activityConfig';

export default {
  name: 'template2',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showDetail: false,
      showPopup: false,
      popupItem: null,
      effectiveSubCount: 0,
      recommendList,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  computed: {
    inviteLink() {
      const id = this.activityData.id || '7';
      return `https://153.43.88.132:18026/?id=${id}`;
    },
    activityMemo() {
      const id = this.activityData.id || '7';
      const item = this.recommendList.find(i => i.activityId === String(id));
      return item ? item.memo : '';
    },
    // 生成蛇形网格数据（每行4个，共25行100个）
    gridRows() {
      const rows = [];
      for (let r = 0; r < 25; r++) {
        const isReverse = r % 2 === 1;
        const items = [];
        for (let c = 0; c < 4; c++) {
          const num = r * 4 + c + 1;
          items.push({
            num,
            reward: num === 39 ? 150 : 100,
          });
        }
        if (isReverse) {
          items.reverse();
        }
        rows.push({ items, isReverse });
      }
      return rows;
    },
  },
  methods: {
    copyLink() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.inviteLink).then(() => {
          this.$notify({ type: 'success', message: '链接复制成功' });
        }).catch(() => {
          this.$notify({ type: 'danger', message: '复制失败' });
        });
      } else {
        const input = document.createElement('input');
        input.value = this.inviteLink;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$notify({ type: 'success', message: '链接复制成功' });
      }
    },
    handleShare() {
      if (navigator.share) {
        navigator.share({
          title: '邀请注册',
          text: '邀请您注册，一起赚钱！',
          url: this.inviteLink,
        });
      } else {
        this.copyLink();
      }
    },
    shareToPlatform(type) {
      const shareUrl = encodeURIComponent(this.inviteLink);
      const shareText = encodeURIComponent('邀请您注册，一起赚钱！');

      switch (type) {
        case 'wechat':
          const wechatUrl = `weixin://dl/business/?ticket=${encodeURIComponent(this.inviteLink)}`;
          window.open(wechatUrl);
          break;
        case 'qq':
          const qqUrl = `mqq://shareui/openshare?url=${shareUrl}&title=${shareText}`;
          window.open(qqUrl);
          break;
        case 'moments':
          const momentsUrl = `weixin://dl/moments?url=${shareUrl}`;
          window.open(momentsUrl);
          break;
        case 'facebook':
          const fbUrl = `fb://share?href=${shareUrl}`;
          window.open(fbUrl);
          break;
        case 'telegram':
          const tgUrl = `tg://msg_url?url=${shareUrl}&text=${shareText}`;
          window.open(tgUrl);
          break;
      }
    },
    goRecommend(item) {
      if (item.popup === 1) {
        this.popupItem = item;
        this.showPopup = true;
      } else if (item.url_open === 1 && item.url) {
        window.location.href = item.url;
      } else if (item.jump) {
        this.$router.replace(`/activityDetail?template=${item.templateId}&activity_id=${item.activityId}&from=${this.from}`).catch(() => {});
      }
    },
    closePopup() {
      this.showPopup = false;
      this.popupItem = null;
    },
    scrollToActive() {
      const activeIndex = this.recommendList.findIndex(item => item.activityId === String(this.activityData.id));
      if (activeIndex === -1) return;

      const wrap = this.$refs.recommendWrap;
      const items = this.$refs['recItem' + activeIndex];
      if (!wrap || !items || !items[0]) return;

      const itemEl = items[0];
      const wrapWidth = wrap.offsetWidth;
      const itemLeft = itemEl.offsetLeft;
      const itemWidth = itemEl.offsetWidth;

      const scrollLeft = itemLeft - (wrapWidth / 2) + (itemWidth / 2);
      wrap.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.template2 {
  padding-bottom: 1.2rem;
  background: #1e1f24;
  min-height: 100vh;
}

.t2-content {
  padding: 0.2rem;
  margin-bottom: 2rem;
}

// QR码分享区域
.t2-qr-section {
  background: #333436;
  border-radius: 0.16rem;
  padding: 0.2rem;
  box-sizing: border-box;
  margin-bottom: 0.24rem;

  .t2-qr-top {
    display: flex;

    .t2-qr-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
      border-radius: 0.1rem;
      padding: 0.15rem;
      margin: 0.2rem;

      .t2-qr-placeholder {
        width: 1.5rem;
        height: 1.5rem;
        background: #fff;
        border-radius: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.1rem;
      }

      .t2-qr-tip {
        color: #333;
        font-size: 0.22rem;
        font-weight: bold;
      }
    }

    .t2-qr-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .t2-share-link {
        display: flex;
        align-items: center;
        background: #292a2c;
        border-radius: 0.08rem;
        padding: 0.1rem;
        margin-bottom: 0.15rem;

        .t2-link-input {
          flex: 1;
          background: transparent;
          border: none;
          outline: none;
          color: #fff;
          font-size: 0.28rem;
          padding: 0;
          box-sizing: border-box;
        }

        .t2-link-copy {
          color: #DFB372;
          margin-left: 0.1rem;
          cursor: pointer;
          flex-shrink: 0;
        }
      }

      .t2-share-buttons {
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
        gap: 0.3rem;
        padding-right: 0.1rem;

        &::-webkit-scrollbar {
          display: none;
        }

        .t2-share-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          flex-shrink: 0;

          .t2-share-icon-share {
            width: 1.1rem;
            height: 1.1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.08rem;
          }

          .t2-share-icon-img {
            width: 1.1rem;
            height: 1.1rem;
            object-fit: contain;
            margin-bottom: 0.08rem;
          }

          .t2-share-text {
            color: #898989;
            font-size: 0.3rem;
            text-align: center;
            margin-top: 0.1rem;
          }
        }
      }
    }
  }

  // 有效下级信息
  .t2-sub-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.15rem 0;
    margin-top: 0.15rem;
    font-size: 0.28rem;
    color: #ccc;

    strong {
      color: #DFB372;
    }

    .t2-detail-link {
      color: #DFB372;
      cursor: pointer;
    }
  }
}

// 说明卡片
.t2-explain-card {
  background: #292a2c;
  border-radius: 0.25rem;
  padding: 0.3rem;
  margin-bottom: 0.2rem;

  .t2-explain-title {
    text-align: center;
    font-size: 0.3rem;
    color: #fff;
    font-weight: 600;
    margin-bottom: 0.2rem;
  }

  .t2-explain-text {
    font-size: 0.28rem;
    color: #ccc;
    line-height: 1.6;

    p {
      margin-bottom: 0.1rem;
    }

    strong {
      color: #fff;
    }

    .more-link {
      color: #DFB372;
      cursor: pointer;
    }
  }
}

// 推广奖励网格
.t2-grid-section {
  background: #292a2c;
  border-radius: 0.15rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
}

.t2-grid-container {
  display: grid;
  grid-template-columns: 1fr 0.5rem 1fr 0.5rem 1fr 0.5rem 1fr;
  gap: 0;
}

.t2-grid-row {
  display: grid;
  grid-template-columns: 1fr 0.5rem 1fr 0.5rem 1fr 0.5rem 1fr;
  position: relative;
  align-items: stretch;
}

.t2-grid-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.t2-arrow-h-col {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.35rem;
  color: #ccc;
  font-weight: bold;
}

.t2-arrow-h-col.is-reverse {
  margin-right: 0.2rem;
}

.t2-arrow-h-col:not(.is-reverse) {
  margin-left: 0.2rem;
}

.t2-v-arrow-row {
  display: grid;
  grid-template-columns: 1fr 0.5rem 1fr 0.5rem 1fr 0.5rem 1fr;
  padding: 0.05rem 0;
}

.t2-v-arrow-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.35rem;
  color: #ccc;
  font-weight: bold;
  transform: rotate(90deg);
  min-height: 0.4rem;
}

.t2-cell-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.t2-cell-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('/static/image/event/tghdhb3_s.avif') center/cover no-repeat;
  border-radius: 0.1rem;
  padding: 0.15rem 0.1rem;
  min-width: 1.5rem;
}

.t2-cell-btn {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: #ccc;
  color: #646566;
  font-size: 0.22rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.05rem;
}

.t2-cell-label {
  font-size: 0.22rem;
  color: #fff;
  margin-bottom: 0.05rem;
}

.t2-cell-reward {
  font-size: 0.24rem;
  color: #898989;
  font-weight: 600;
  text-align: center;
  margin-top: 0.05rem;
}

// 箭头
.t2-arrow-h {
  font-size: 0.3rem;
  color: #ccc;
  font-weight: bold;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.5rem;
}

.t2-arrow-v {
  text-align: center;
  font-size: 0.35rem;
  color: #ccc;
  font-weight: bold;
  padding: 0.05rem 0;
  width: 100%;
  transform: rotate(90deg);
}

.t2-h-arrow-abs {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.35rem;
  color: #ccc;
  font-weight: bold;
  z-index: 1;
}

.t2-v-arrow-abs {
  position: absolute;
  bottom: -0.5rem;
  transform: translateX(-50%) rotate(90deg);
  font-size: 0.35rem;
  color: #ccc;
  font-weight: bold;
  line-height: 1;
}

.t2-arrow-v-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.05rem 0;
}

.t2-arrow-v-cell {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.35rem;
  color: #ccc;
  font-weight: bold;
  transform: rotate(90deg);
  height: 0.45rem;
}

.t2-arrow-v-spacer {
  height: 0.45rem;
  width: 100%;
}

// 活动说明卡片
.t2-rules-card {
  background: #292a2c;
  border-radius: 0.15rem;
  padding: 0.3rem;
  margin-bottom: 0.2rem;
}

.t2-rules-title-wrap {
  margin-bottom: 0.2rem;
}

.t2-rules-title {
  display: inline-block;
  background: #DFB372;
  color: #000;
  font-size: 0.32rem;
  font-weight: 600;
  padding: 0.1rem 0.3rem;
  border-radius: 0 0.3rem 0.3rem 0;
}

.t2-rules-content {
  font-size: 0.3rem;
  color: #ccc;
  line-height: 1.8;

  p {
    margin-bottom: 0.1rem;
  }
}

// 底部推荐图
.t2-recommend {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.2rem;

  .t2-recommend-inner {
    display: flex;
    gap: 0.15rem;
    width: max-content;
    margin-top: 1rem;
  }

  .t2-recommend-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: thin solid transparent;
    border-radius: 0.1rem;
    box-sizing: border-box;

    &.t2-recommend-active {
      border: thin solid #d1ae52;
    }
  }

  .t2-recommend-img {
    width: 2.5rem;
    border-radius: 0.1rem;
    flex-shrink: 0;
    object-fit: cover;
  }

  .t2-recommend-name {
    width: 2.5rem;
    font-size: 0.24rem;
    color: #ccc;
    text-align: center;
    margin-top: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

// 弹框
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .popup-content {
    position: relative;
    width: 80%;
    max-width: 3rem;
    background: #292a2c;
    border-radius: 0.1rem;
    padding: 0.2rem;
  }

  .popup-close {
    position: absolute;
    top: -0.4rem;
    right: -0.4rem;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .popup-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .popup-img {
    width: 100%;
    border-radius: 0.1rem;
    margin-bottom: 0.1rem;
  }

  .popup-name {
    font-size: 0.28rem;
    color: #fff;
    text-align: center;
  }
}
</style>

<style>
.t2-rules-content strong {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail/template2.vue